import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
export const getReportRhumbConfig = (successMarkerName, errorMarkerName) => ({
  renderSuccessMarker: () => /*#__PURE__*/_jsx(NavMarker, {
    name: successMarkerName
  }),
  errorMarkerName: errorMarkerName ? () => /*#__PURE__*/_jsx(NavMarker, {
    name: errorMarkerName
  }) : undefined
});